<template>
	<div class="section-milestones padding-top-70 padding-bottom-70">
		<section-title component-class="title-white">
			<h2 v-if="isLoggedIn">
				<span class="fw-400">{{ $t('Section.MilestonesContainerSentenceLogged1') }}</span>
				{{ $t('Section.MilestonesContainerSentenceLogged2') }}
			</h2>
			<h2 v-else>
				<!-- <span class="fw-400">{{ $t('Section.MilestonesContainerSentence1') }}</span> -->
				{{ $t('Section.MilestonesContainerSentence2') }}
			</h2>
			<p v-if="isLoggedIn" v-html="$t('Section.MilestonesContainerSentenceLogged3', ['/profile'])"></p>
		</section-title>

		<div v-if="milestones" class="container" :class="{ 'margin-top-60': isLoggedIn }">
			<div class="row">
				<milestones-container-box
					v-for="(value, key) in milestones"
					v-once
					:key="key"
					:item="value"
					:compact="!isLoggedIn || (isLoggedIn && isUserAccount)"
				></milestones-container-box>
			</div>
		</div>
	</div>
</template>

<script>
import AccountInfo from '@/mixins/AccountInfo'
import Helpers from '@/mixins/Helpers'
import MilestonesContainerBox from '@/components/sections/boxes/MilestonesContainerBox'
import SectionTitle from '@/components/partials/SectionTitle'
import ServiceHelper from '@/mixins/ServiceHelper'

export default {
	name: 'MilestonesContainer',
	components: {
		MilestonesContainerBox,
		SectionTitle,
	},
	mixins: [AccountInfo, Helpers, ServiceHelper],
	data() {
		return {
			milestones: null,
		}
	},
	created() {
		// if (sessionStorage.getItem('ius_milestones')) {
		// 	// If available, use session storage milestones
		// 	this.milestones = JSON.parse(sessionStorage.getItem('ius_milestones'))
		// } else {
		// 	// Retrieve milestones from API and store in session storage
		// 	this.loadData()
		// }
		this.loadData()
	},
	methods: {
		loadData() {
			if (this.isLoggedIn) {
				if (this.account) {
					// Get account recap data
					this.setAuthorizationToken()
					axios
						.get('/' + (!this.isUserAccount ? 'lawyers' : 'users') + '/statistics/' + this.account.id)
						.then((response) => {
							this.milestones = response.data.info

							if (!this.isUserAccount) {
								this.milestones.push({
									name: 'Responses approved',
									type: 24,
									count: this.responsesApproved,
								})
							} else {
								this.milestones.push({
									name: 'Requests done',
									type: 12,
									count: this.requestsDone,
								})
								this.milestones.push({
									name: 'Requests pending',
									type: 13,
									count: this.requestsPending,
								})
							}

							//sessionStorage.setItem('ius_milestones', JSON.stringify(this.milestones))
						})
						.catch((error) => {
							console.log(error)
						})
				}
			} else {
				// Get site data
				axios
					.get('/statistics/milestones', {
						params: this.loadAllParams,
					})
					.then((response) => {
						this.milestones = [
							{ name: 'Mesi dal Lancio', type: 6, count: 37 },
							{ name: 'Avvocati per Tipologia Richiesta', type: 5, count: 1688 },
							{ name: 'Grado di Soddisfazione Utenti', type: 4, count: 4.5 },
						]
						//sessionStorage.setItem('ius_milestones', JSON.stringify(this.milestones))
					})
					.catch((error) => {
						console.log(error)
					})
			}
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/sections/MilestonesContainer.vue